import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './OrSeparator.module.scss';

const OrSeparator = () => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.separator}>
      <div className={styles.line} />
      <span className={styles.text}>{t('or')}</span>
      <div className={styles.line} />
    </div>
  );
};

export default OrSeparator;
